<template>
  <div id="app" class="container">
    <header>
      <div class="logo-wrapper mt-3 mb-5 d-flex">
        <router-link to="/">
          <img
            class="logo-onboarding"
            :src="getLogoUrl()"
            :alt="$t('company_shortname')"
          />
        </router-link>
        <LanguageDropdown
          v-if="showLanguageDropdown"
          class="d-inline-flex ml-auto"
        />
      </div>
      <!--      <nav class="main-menu" v-if="$route.name !== 'successScreen'">-->
      <!--        <ul>-->
      <!--          <li v-for="step in steps">-->
      <!--            <router-link :to="step.route" :event="null" class="disabled-link">{{-->
      <!--              step.name-->
      <!--            }}</router-link>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </nav>-->
      <!--      <h4>{{ document.title }}</h4>-->
    </header>
    <div class="main-content mt-1">
      <alert />
      <horizontal-stepper
        v-if="$route.name === 'home'"
        class="mt-4"
        :heading="
          $t('open_account_takes_minutes', {
            company_fullname: $t('company_fullname')
          })
        "
        :steps="steps"
        :keep-alive="false"
        :key="$i18n.locale"
        @completed-step="completeStep"
        @active-step="isStepActive"
        @stepper-finished="alert"
      >
      </horizontal-stepper>
      <router-view :key="$i18n.locale" v-else />
    </div>
  </div>
</template>

<script>
import Alert from "./components/Alert";
import LanguageDropdown from "@/components/LanguageDropdown";
import HorizontalStepper from "@/components/HorizontalStepper";
import PersonalInformation from "@/views/PersonalInformation";
import InvestmentQuestionnaire from "@/views/InvestmentQuestionnaire";
import Summary from "@/views/Summary";
import Strategies from "@/views/Strategies";
import Documentation from "@/views/Documentation";
import Documents from "@/views/Documents";
import Verification from "@/views/Verification";

export default {
  name: "App",
  components: {
    Alert,
    HorizontalStepper,
    LanguageDropdown
  },
  watch: {
    "$route.name"(routeName) {
      this.setTitle(routeName);
    }
  },
  computed: {
    logo() {
      const publicPath = process.env.VUE_APP_PUBLIC_PATH
        ? process.env.VUE_APP_PUBLIC_PATH
        : "/";
      return publicPath + "images/logo.haberl.svg";
    },
    steps() {
      return [
        {
          number: "1",
          name: "personalInfo",
          title: this.$t("registration_form"),
          component: PersonalInformation,
          back: false,
          next: false,
          submit: true,
          completed: false
        },
        {
          number: "2",
          name: "questionnaire",
          title: this.$t("questionnaire"),
          component: InvestmentQuestionnaire,
          back: false,
          next: true,
          submit: true,
          completed: false
        },
        {
          number: "3",
          name: "summary",
          title: this.$t("summary"),
          component: Summary,
          back: true,
          next: true,
          submit: true,
          completed: false
        },
        {
          number: "4",
          name: "strategies",
          title: this.$t("strategy_selection"),
          component: Strategies,
          back: false,
          next: true,
          submit: true,
          completed: false
        },
        {
          number: "5",
          name: "documentation",
          title: this.$t("documentation"),
          component: Documentation,
          back: false,
          next: true,
          submit: false,
          completed: false
        },
        {
          number: "6",
          name: "documents",
          title: this.$t("documents"),
          component: Documents,
          back: false,
          next: true,
          submit: true,
          completed: false
        },
        {
          number: "7",
          name: "verification",
          title: this.$t("verification"),
          component: Verification,
          back: false,
          next: true,
          submit: true,
          completed: false
        }
      ];
    }
  },
  mounted() {
    this.setTitle(this.$route.name);
    this.$store.commit("onboarding/initBrowser");
  },
  methods: {
    setTitle(routeName) {
      let title = "";
      const step = this.steps.find(item => {
        return item.title === routeName;
      });
      if (step !== undefined) {
        title += step.name + " - ";
      }
      title += this.$t("company_shortname");
      document.title = title;
    },
    completeStep(payload) {
      this.steps.forEach(step => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.steps.forEach(step => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    reset() {
      console.log("reset");
    },
    // Executed when @stepper-finished event is triggered
    alert() {
      this.$router.push({ name: "successScreen" });
    }
  },
  data() {
    return {
      allowedRoutes: ["login", "activation"],
      showLanguageDropdown: process.env.VUE_APP_LOCALES.split(",").length > 1
    };
  }
};
</script>

<style lang="scss">
.main-content {
  margin-top: 60px;
}

.main-menu {
  list-style: none;

  ul {
    margin: 0;
    padding: 0;
    text-align: center;

    > li {
      display: inline-block;

      &:not(:last-child):after {
        content: "\00B7";
        font-weight: bold;
      }

      > a {
        padding: 0 20px;
        text-transform: uppercase;
        color: #818181;
        font-size: 18px;

        &.router-link-exact-active {
          color: $yellow;
          font-weight: bold;
        }
      }
    }
  }
}

.disabled-link:hover {
  text-decoration: none;
  cursor: default;
}

.logo-onboarding {
  margin-top: 10px;
  height: 40px;
}
</style>
